import { useMutation, useQueryClient } from '@tanstack/react-query';
import { InviteMemberBoardTypes, PayloadBoardTypes } from 'components/types/boardList';
import { http } from 'helpers/http';
import { useDispatch } from 'react-redux';
import { HIT_BOARD_STATUS } from 'redux/actions/board';
import { DO_LOADING } from 'redux/actions/loading';

interface PropsCategoryMember {
  endpoint: string,
  boardId: string,
}

const URL = process.env.REACT_APP_API;

export const useUpdateBOBoard = (companyId:string | null) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updateCompany: PayloadBoardTypes) => {
      const response = await http.post(`${URL}bo-company/board-update`, updateCompany);
      return response.data;
    },
    onMutate: () => {
      dispatch({ type: DO_LOADING, payload: true });
    },
    onSuccess: (responseData) => {
      void queryClient.invalidateQueries({ queryKey: ['bo-company/list-board', companyId] });
      const successMesage = responseData.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: successMesage,
        },
      });
    },
    onError: (error: any) => {
      const errorMessage = error.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: errorMessage,
        },
      });
    },
    onSettled: () => {
      dispatch({ type: DO_LOADING, payload: false });
    },
  });
};

const useCategoryMutationMemberBoard = <T>({ endpoint, boardId }: PropsCategoryMember) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dataUpdate: T) => {
      const response = await http.post(`${URL}${endpoint}`, dataUpdate);
      return response.data;
    },
    onMutate: () => {
      dispatch({ type: DO_LOADING, payload: true });
    },
    onSuccess: (responseData) => {
      void queryClient.invalidateQueries({ queryKey: ['bo-company/board-list-member', boardId] });
      const successMesage = responseData.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'success',
          message: successMesage,
        },
      });
    },
    onError: (error: any) => {
      const errorMessage = error.message;
      dispatch({
        type: HIT_BOARD_STATUS,
        payload: {
          status: 'failed',
          message: errorMessage,
        },
      });
    },
    onSettled: () => {
      dispatch({ type: DO_LOADING, payload: false });
    },
  });
};

export const useInviteMemberBoard = (boardId: string | null) => useCategoryMutationMemberBoard({
  boardId,
  endpoint: 'bo-company/board-invite',
});

export const useDeleteMemberBoard = (boardId: string | null) => useCategoryMutationMemberBoard({
  boardId,
  endpoint: 'bo-company/board-delete-member',
});
